import ApplicationSerializer from 'eflex/serializers/application';

export default class WieConfigImageSerializer extends ApplicationSerializer {
  attrs = {
    stroke: {
      embedded: 'always',
    },
  };
}
